<template>
  <div class="TypeOptions">
    <h4>Edtools</h4>
    <ul>
      <li v-for="(filter,index) in FullToolsFilters" :key="'edtoolfilter' + index"><CheckInput :key="'checkInput-'+'edtoolsfilter-' + index" :item="filter"/></li>
    </ul>
    <h4>Other Learning Tools</h4>
    <ul>
      <li v-for="(filter,index) in FullOtherToolsFilters" :key="'otherlearningfilter' + index"><CheckInput :item="filter"/></li>
    </ul>
  </div>
</template>

<script>
var ToolsFilters = window.drupalSettings ? window.drupalSettings.searchFilters.tools : null
var OtherToolsFilters = window.drupalSettings ? window.drupalSettings.searchFilters.other_tools : null

import CheckInput from '@/components/CheckInput'
export default {
  name: 'TypeOptions',
  components: { CheckInput },
  mounted: function () {
    if (ToolsFilters == null) {
      ToolsFilters = this.$parent.backupSettings.tools
    }

    if (OtherToolsFilters == null) {
      OtherToolsFilters = this.$parent.backupSettings.other_tools
    }

    this.FullToolsFilters = Object.keys(ToolsFilters).map((el, index) => {
      if (el === 'collection') {
        ToolsFilters[el] = 'EDCollections'
      }
      return {
        shortname : el,
        name : ToolsFilters[el],
        id : index,
        resultsCount: 0,
        kind: 'type'
      }
    })

    this.FullOtherToolsFilters = Object.keys(OtherToolsFilters).map((el, index) => {
      if (el === 'collection') {
        OtherToolsFilters[el] = 'EDCollections'
      }
      return {
        shortname : el,
        name : OtherToolsFilters[el],
        id : index,
        resultsCount: 0,
        kind: 'type'
      }
    })
  },
  data () {
    return {
      FullToolsFilters: null,
      FullOtherToolsFilters: null
    }
  }
};
</script>

<style scoped lang="scss">

</style>
